export const FREE_TRIAL_PROMO_CODES = [
  "5IRON3D",
  "SB3DDryvebox",
  "SB3DPNGC",
  "MICHELLE",
];
